import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { FloatingInputComponent } from '../inputs/floating-input/floating-input.component';
import { OverlayGeneralComponent } from '../overlays/overlay-general/overlay-general.component';
import { dropdownOverlayPositions } from '../overlays/option-list.constants';
import { TooltipDirective } from '@app/directives/tooltip.directive';

@Component({
  selector: 'app-custom-input-overlay-dropdown',
  template: ` <app-floating-input
      #optionsTrigger="cdkOverlayOrigin"
      #floatingInputComponent
      (click)="showDropdown()"
      (ngModelChange)="modelChange.emit($event)"
      [(ngModel)]="model"
      [autoComplete]="autoComplete"
      [iconClass]="iconClass"
      [label]="label"
      [name]="name"
      [inputClass]="isReadOnly ? 'cursor-pointer' : ''"
      [wrapperClass]="isReadOnly ? 'cursor-pointer' : ''"
      [placeholder]="placeholder"
      [required]="required"
      [readonly]="isReadOnly"
      (focusout)="isReadOnly = true"
      cdkOverlayOrigin
    >
      @if (isEdited) {
        <i
          secondaryIcon
          (click)="editTemplateName($event)"
          appTooltip="Rename checklist"
          class="text-blue-700 p-input-icon-right icon-pencil-block right-8"
        ></i>
      }
    </app-floating-input>

    <app-overlay-general
      (optionSelected)="optionSelected.emit($event)"
      [(show)]="isDropdownShown"
      [overlayPositions]="dropdownOverlayPositions"
      [trigger]="optionsTrigger"
      [withAnimation]="withAnimation"
    >
      <ng-content></ng-content>
    </app-overlay-general>`,
  imports: [
    CdkOverlayOrigin,
    FloatingInputComponent,
    OverlayGeneralComponent,
    TooltipDirective,
    FormsModule,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class CustomInputOverlayDropdownComponent implements OnInit {
  @ViewChild('floatingInputComponent') floatingInputComponent: FloatingInputComponent;

  @Input() model: any;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() name: string;
  @Input() autoComplete: boolean;
  @Input() required: boolean;
  @Input() withAnimation = true;
  @Input() iconClass: string;
  isDropdownShown = false;
  @Input() isEdited = false;

  @Output() modelChange = new EventEmitter();
  @Output() optionSelected = new EventEmitter();

  protected readonly dropdownOverlayPositions = dropdownOverlayPositions;
  isReadOnly = true;

  showDropdown() {
    this.isDropdownShown = true;
  }

  hideDropdown() {
    this.isDropdownShown = false;
  }

  ngOnInit(): void {}

  editTemplateName(event: MouseEvent) {
    event.stopPropagation();
    this.isReadOnly = false;
    this.floatingInputComponent.inputElement().nativeElement.focus();
  }
}
